import { createFileRoute } from "@tanstack/react-router";
import DifferenceBetweenAnxietyAndDepressionPage from "@/pages/articles/DifferenceBetweenAnxietyAndDepressionPage";
export const Route = createFileRoute(
  "/what-is-the-difference-between-anxiety-and-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anxiety vs Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What is the difference between anxiety and depression? Learn the symptoms, overlap, and treatment options at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Anxiety vs Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What is the difference between anxiety and depression? Learn the symptoms, overlap, and treatment options at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-is-the-difference-between-anxiety-and-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-the-difference-between-anxiety-and-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DifferenceBetweenAnxietyAndDepressionPage />;
}
